export default {"src":"/_next/static/media/Cloud.2f751015.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};